<template>
  <v-menu
    v-if="true"
    v-model="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="computedDateFormatted"
        :label="$t('Выберите дату')"
        outlined
        readonly
        hide-details="auto"
        :disabled="disabled"
        class="mt-0"
        dense
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <div v-if="getFormatedLocale() === 'ru-ru'">
      <v-date-picker
        v-model="date"
        no-title
        color="primary"
        :min="minDate"
        :locale="getFormatedLocale()"
        first-day-of-week="1"
        :weekday-format="getDay"
        :allowed-dates="allowedDates"
        @input="dateMenu = false"
        @change="emitChanges"
      ></v-date-picker>
    </div>
    <div v-else>
      <v-date-picker
        v-model="date"
        no-title
        color="primary"
        :min="minDate"
        :locale="getFormatedLocale()"
        :allowed-dates="allowedDates"
        first-day-of-week="1"
        @input="dateMenu = false"
        @change="emitChanges"
      ></v-date-picker>
    </div>
  </v-menu>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'
import { mdiCalendar } from '@mdi/js'
import { toLocalDay } from '@/utils/helper'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    onPage: {
      type: String,
      required: true,
    },
    dayOff: {
        type: Number,
        default: null,
        required: false,
    },
    daysOff: {
        type: Array,
        default: () => [],
        required: false,
    },

    // Конкретные даты-выходные ('YYYY-MM-DD'). Если непусто — блокируем по ним;
    // иначе fallback на daysOff (дни недели) на период перехода.
    daysOffDates: {
        type: Array,
        default: () => [],
        required: false,
    },
    dateValue: {
      type: String,
      required: false,

      // Функцией, а не значением: иначе дата вычислялась бы один раз при
      // загрузке страницы и после полуночи оставалась вчерашней.
      default: () => toLocalDay(),
    },

    // Минимальный срок подачи заявки в днях (настройка объекта в админке):
    // 1 — не раньше завтра, 2 — не раньше послезавтра, 0 — можно на сегодня.
    minDaysBefore: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const date = ref(props.dateValue)

    // Раньше нижняя граница была жёстко «сегодня». Теперь сдвигаем её на срок
    // подачи, заданный у объекта музея.
    const minDate = computed(() => {
      if (props.onPage !== 'new-request-date') {
        return toLocalDay(new Date(1995, 7, 3))
      }
      const from = new Date()
      from.setDate(from.getDate() + Number(props.minDaysBefore || 0))

      // Местная дата, а не UTC: иначе ночью нижняя граница съезжала на день назад
      // и запрет на ближайшие даты не срабатывал.
      return toLocalDay(from)
    })
    const dayOff = ref(props.dayOff)
    const dateMenu = ref(false)
    const daysOfWeek = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    const formatDate = dates => {
      if (!dates) return null
      const [year, month, day] = dates.split('-')

      return `${day}.${month}.${year}`
    }
    const getDay = currentDate => {
      const i = new Date(currentDate).getDay(currentDate)

      return daysOfWeek[i]
    }

    let dateFormatted = formatDate(toLocalDay())

    const getFormatedLocale = () => {
        const locale = localStorage.getItem('locale') || 'ru'
        if (locale === 'zh') {
            return 'zh-cn'
        } if (locale === 'en') {
            return 'en-us'
        } if (locale === 'ru') {
            return 'ru-ru'
        } if (locale === 'fa') {
            return 'fa-ir'
        } if (locale === 'vi') {
            return 'vi-vn'
        }

return 'ru-ru'
    }

    const allowedDates = val => {
      // val приходит из Vuetify как строка 'YYYY-MM-DD'.
      // Приоритет — конкретные даты: сравниваем строки, без new Date (без сдвига TZ).
      if (props.daysOffDates.length) {
        return !props.daysOffDates.includes(val)
      }

      // Fallback на период перехода: старая логика дней недели.
      const weekday = new Date(val).getDay()

      return weekday !== dayOff.value && !props.daysOff.includes(weekday)
    }

    const parseDate = dates => {
      if (!dates) return null
      const [month, day, year] = dates.split('.')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    const computedDateFormatted = computed(() => formatDate(date.value))

    watch(date, () => {
      dateFormatted = formatDate(date.value)
    })

    const emitChanges = () => {
      emit('newDate', { date: date.value, onPage: props.onPage })
    }

    return {
      date,
      minDate,
      dateFormatted,
      dateMenu,
      computedDateFormatted,
      parseDate,
      formatDate,
      icons: {
        mdiCalendar,
      },
      allowedDates,
      emitChanges,
      getDay,
      getFormatedLocale,
    }
  },
}
</script>
